import classNames from "classnames";
import intl from "react-intl-universal";

import {useAppState} from "@stores/AppStateContext";

import React, {MouseEvent} from "react";

import {MODALS} from "../../screens/modals/modal-names";


import "./UpgradeNotice.css"


export interface UpgradeNoticeProps {
    className?: string
    type?: 'ai' | 'primary',
}

export const UpgradeNotice = ({className, type}: UpgradeNoticeProps) => {
    const appState = useAppState();
    const btnUpgradePlan = (event: MouseEvent<HTMLDivElement>) => {
        /* @ts-ignore */
        if (event.target.tagName !== 'BUTTON') {
            return;
        }
        appState.setModal({name: MODALS.CHECKOUT, params: undefined});
    };

    const htmlStart = `<button class="UpgradeNotice__Button btn btn--inline btn--${type} btn--sm btn--withIcon btn--clickable title-small"><span class="material-symbols-rounded btn__icon UpgradeNotice__icon">rocket_launch</span>`
    const htmlEnd =`</button>`

    return (
        <div className={classNames({
            [className!]: className
        })}
             onClick={btnUpgradePlan}>
                {intl.getHTML(`UpgradeNotice`, {htmlStart, htmlEnd}).d(`<span class="UpgradeNotice">${htmlStart}Upgrade${htmlEnd}<span class="UpgradeNotice__text body-medium">your plan to get more</span></span>`)}
        </div>
    )
}
